import type { ReactElement } from 'react';
import { Badge } from '@/components/ui/badge';
import type { MCPProvenance } from '@kirin/api-client/contracts/mcp';

interface MCPSourceBadgeProps {
  /** Undefined = legacy (pre-union) row, treated as endpoint. */
  provenance?: MCPProvenance;
}

/** Badge distinguishing gateway-managed rows from endpoint-reported rows (KIR-3940). */
export function MCPSourceBadge({
  provenance,
}: MCPSourceBadgeProps): ReactElement {
  const isGateway = provenance === 'gateway';
  return (
    <Badge
      variant="outline"
      className={
        isGateway
          ? 'border-purple-200 bg-purple-100 text-purple-700 dark:border-purple-800 dark:bg-purple-950 dark:text-purple-300'
          : 'border-gray-200 bg-gray-100 text-gray-600 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400'
      }
    >
      {isGateway ? 'MCP Gateway' : 'Endpoint Agent'}
    </Badge>
  );
}
